<template>
	<v-container grid-list-md fluid fill-height class="pa-0">
		<v-layout row wrap>
			<v-flex xs12 md3>
				<DiscoverOutletCard
					v-for="(outlet, index) in outlets"
					:key="`card.${index}`"
					:outlet="outlet"
					class="mb-5"
				></DiscoverOutletCard>
			</v-flex>
			<v-flex xs12 md9>
				<GmapMap
					:center="{ lat: latitude, lng: longitude }"
					:zoom="15"
					map-type-id="terrain"
					style="width: 100%; height: 90vh; position: fixed"
					ref="mapRef"
				>
					<GmapMarker
						v-for="(outlet, index) in outlets"
						:key="`marker.${index}`"
						:position="{
							lat: outlet.latitude,
							lng: outlet.longitude,
						}"
						:clickable="true"
						:draggable="false"
					/>
				</GmapMap>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import DiscoverOutletCard from "@Discover/components/DiscoverOutletCard.vue";
export default {
	components: {
		DiscoverOutletCard,
	},
	props: ["outlets"],
	data() {
		return {
			item: {},
		};
	},
	computed: {
		latitude() {
			return this.item.latitude ? this.item.latitude : 11.5564;
		},
		longitude() {
			return this.item.longitude ? this.item.longitude : 104.9282;
		},
	},
};
</script>
